// ResizeObserver polyfill
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = class ResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      this.callback = callback;
    }

    observe() {
      // No-op for polyfill
    }

    unobserve() {
      // No-op for polyfill
    }

    disconnect() {
      // No-op for polyfill
    }

    private callback: ResizeObserverCallback;
  };
}
export {};
